<template>

  <div>


    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">Inici</router-link-locale></li>

        <li v-if="part2" class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{part1}}</router-link-locale></li>
        <li v-else class="breadcrumb-item">{{part1}}</li>

        <li v-if="part2" class="breadcrumb-item active" aria-current="page">{{ part2 }}</li>
      </ol>
    </nav>

  </div>

</template>

<script>

import RouterLinkLocale from "@/components/RouterLinkLocale.vue";

export default {
  name: "BreadcrumbSection",
  components: {RouterLinkLocale},
  props: {
    part1: {
      type:  String,
      required: true
    },
    part2: {
      type:  String,
      required: false
    }
  },

  setup(){

    return{

    }

  }
}

</script>

<style scoped>

</style>
